<template>
  <div id="ponto-interesse-edit">
            <ExibirErrosConcept :errorsValidacao="errorsValidacao" ref="errosComponent"></ExibirErrosConcept>
            <vx-card>       
                <div class="vx-row mb-2">
                    <div class="vx-col w-full">
                        <label class="vs-input--label" >{{$t('TelaPontoInteresse_lGrupo')}}</label>
                        <v-select         
                            label="nome"          
                            :reduce="tipo => tipo.id" 
                            :options="listaCategoriaPontosInteresse"                   
                            v-model="data_local.idGrupo"       
                            class="v-select w-full"></v-select>            
                    </div>               
                </div>

                <div class="vx-row mb-2">
                    <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-1/2 w-full">
                        <vs-input class="w-full" :label="$t('TelaPontoInteresse_lCodigo')" v-model="data_local.codigo" name="CODIGO" />                
                    </div>  
                    <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-1/2 w-full">
                        <vs-input class="w-full" :label="$t('TelaPontoInteresse_lNome')" v-model="data_local.nome" name="nome" />                
                    </div>  
                </div>
                <div class="vx-row">
                    <div class="vx-col w-2/3">
                        <vs-textarea counter="400" class="w-full" :label="$t('TelaPontoInteresse_lDescricao')" v-model="data_local.descricao" name="descricao"  maxlength="1000" />                
                    </div>    
                    <div class="vx-col w-1/3">
                        <label class="vs-input--label" >{{$t('TelaCategoriaPontoInteress_lIcone')}}</label> 
                        <v-select                                                   
                            :reduce="iconePontoInteresse => iconePontoInteresse.data" 
                            :options="listaIconesPontoInteresse" 
                            v-model="data_local.icone"     
                            style="height: 40px">
                            <template slot="option" slot-scope="option">
                                <img :src="`${publicPath}${option.fullImage}`">
                            </template>
                            <template #selected-option="{ fullImage }">
                                <img :src="`${publicPath}${fullImage}`" style="max-height:40px">
                            </template>
                        </v-select>                 
                    </div>                
                </div>
                <div class="vx-row">
                    <div class="vx-col w-1/4 p-0">
                        <vs-checkbox size="small" v-model="data_local.identificarPoI"><small>{{$t('TelaPontoInteresse_lIdentificar')}} ?</small></vs-checkbox>
                    </div>               
                    <div class="vx-col w-1/4 p-0">
                        <vs-checkbox size="small" v-model="data_local.enviarAlertaPoI"><small>{{$t('TelaPontoInteresse_lEnviarAlerta')}} ?</small></vs-checkbox>
                    </div>               
                    <div class="vx-col w-1/4 p-0">
                        <vs-checkbox size="small" v-model="data_local.statusAtivo"><small>{{$t('TelaPontoInteresse_lAtivo')}} ?</small></vs-checkbox>
                    </div>   
                    <div class="vx-col w-1/4 p-0">
                        <vs-checkbox size="small" v-model="data_local.pontoDeInicioFim"><small>{{$t('TelaPontoInteresse_lInicioFimRota')}} ?</small></vs-checkbox>
                    </div>             
                                 
                </div>
                
                <div class="vx-row mt-4 mb-4">
                     
                    <div class="vx-col w-1/2 flex items-center">
                        <label class="vs-input--label mt-2 ml-2 mr-2 w-full" >{{$t('TelaPontoInteresse_lRaio')}} (m)</label>
                        <vs-input v-model="data_local.raio" type="number" />            
                    </div>  
                </div>
                <div class="vx-row mt-4 mb-4">
                    <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-1/2 w-full">
                        {{$t('TelaPontoInteresse_lRestricoes')}}
                    </div>  
                </div>
                <div class="vx-row mb-2">            
                    <div class="vx-col lg:w-1/2 md:w-1/2 sm:w-1/2 w-full">
                        <label class="vs-input--label" >{{$t('TelaPontoInteresse_lHorarioInicial')}}</label>                              
                        <vs-input class="w-full" v-model="data_local.horaInicialRestricao" v-mask="['XX:XX']" icon="calendar_view_day" />            
                    </div>  
                    <div class="vx-col lg:w-1/2 md:w-1/2 sm:w-1/2 w-full">              
                        <label class="vs-input--label" >{{$t('TelaPontoInteresse_lHorarioFinal')}}</label>                              
                        <vs-input class="w-full" v-model="data_local.horaFinalRestricao" v-mask="['XX:XX']" icon="calendar_view_day" />            
                    </div>            
                </div>
                <div class="vx-row mb-2">            
                    <div class="vx-col lg:w-1/2 md:w-1/2 sm:w-1/2 w-full">                              
                        <label class="vs-input--label" >{{$t('TelaPontoInteresse_lAvisoTempoPermanencia')}}</label>                              
                        <vs-input class="w-full"  v-model="data_local.tempoPermanenciaMinimo" type="number" />            
                    </div>  
                    <div class="vx-col lg:w-1/2 md:w-1/2 sm:w-1/2 w-full">              
                        <label class="vs-input--label" >{{$t('TelaPontoInteresse_lLimiteVelocidade')}}</label>                              
                        <vs-input class="w-full"  v-model="data_local.velocidadeMaximaNoPoI" type="number"/>            
                    </div>            
                </div>
            
                <div class="vx-row mb-4">
                    <div class="vx-col md:w-1/2 w-full">                    
                        <vs-button class="ml-auto mt-2" size="small" @click="gravar" :disabled="!temPermissaoGravar && !temCapacidadeMaster" color="success">{{ $t('Btn_Gravar') }}</vs-button>            
                    </div>
                </div>
            </vx-card>
        </div>
</template>

<script>
import axios from "@/axios.js"
import generico from '@/generico.js'
import { CONSTANTE_ICONES_PONTO_INTERESSE } from '@/constantesImagens.js'

const URL_SERVLET = "/PontoInteresseRestServlet";


export default {    
  props: {
    pLatitude: {
      type: String,
      required: true
    },
    pLongitude: {
      type: String,
      required: true
    },
  },
  data() {
    return {   
        tipoPontoInteresse: 'circulo',         
        errorsValidacao: [],  
        data_local: {codigo: null, nome: null, descricao: null, icone: null, idGrupo: null, latitude: this.pLatitude, longitude: this.pLongitude, raio: 1000,
            identificarPoI: false, enviarAlertaPoI: false, poligonoPoI: null, horaInicialRestricao: null, horaFinalRestricao: null,
            pontoDeInicioFim: false, velocidadeMaximaNoPoI: null, bloquearNoPoI: false, tempoPermanenciaMinimo: null , statusAtivo: true },
        listaCategoriaPontosInteresse : [],
        ciculoPerimetro: null,
        listaIconesPontoInteresse: [],
        publicPath: process.env.BASE_URL 
    }
  },    
  mounted() {
    this.listaIconesPontoInteresse = CONSTANTE_ICONES_PONTO_INTERESSE;
    this.fetchListaGruposPontoInteresse();
  },
  computed: {  
    temCapacidadeMaster(){
      if (this.isAcessoMaster) {
        return true;
      } else if (this.isAcessoGrupo) {
        return this.$store.state.AppActiveUser.capacidadeMaster;
      }
      return false;
    },
    temPermissaoGravar(){
      if (this.isAcessoMaster) {
        return true;
      } else if (this.isAcessoGrupo) {
        return this.$store.state.AppActiveUser.grupoPodeSeAlterar;
      }
      return false;
    },
    isAcessoMaster() {
        return this.$store.getters.isAcessoMaster;
    },
    isAcessoIndividual(){
        return this.$store.getters.isAcessoIndividual;
    },
    isAcessoGrupo(){
        return this.$store.getters.isAcessoGrupo;
    },   
    validateForm() {
      return !this.errors.any()
    }
  },
  methods: {   
    fetchListaGruposPontoInteresse() {      
      const params = new URLSearchParams();
      params.append('method', 'FindAll');
      params.append('orderDirection', 'ASC');
      params.append('outputFormat', 'JSON');
      params.append('idCliente', this.$store.state.AppActiveUser.id);
      
      axios.post("/GruposPontoInteresseRestServlet", params, {              
              credentials: 'include',
              responseEncoding: 'iso88591',
              withCredentials: true } )
      .then((response) => {
          if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
              this.$router.push({ path: '/login' });
          } else {
              this.listaCategoriaPontosInteresse = response.data;                                       
          }
      })
      .catch((error) => { 
          /* eslint-disable no-console */  console.log("EFETUAR LOGOFF! - fetchListaGruposPontoInteresse- " + error); 
      })    
                        
    },
    gravar() {        
        if (this.formularioValido()) { 

            const params = new URLSearchParams();        
            params.append('outputFormat', 'JSON');
            params.append('idCliente', this.$store.state.AppActiveUser.id);
           
            params.append('method', 'Insert');      
            params.append('codigo', this.data_local.codigo);      
            params.append('nome', this.data_local.nome);  
            if (this.data_local.descricao) {  
                params.append('descricao', this.data_local.descricao); 
            }     
            params.append('icone', this.data_local.icone); 
            params.append('idGrupo', this.data_local.idGrupo);              
            params.append('latitude', this.data_local.latitude);      
            params.append('longitude', this.data_local.longitude);                  
            params.append('raio', this.data_local.raio/1000.0);             
            params.append('identificarPoI', this.data_local.identificarPoI);      
            params.append('enviarAlertaPoI', this.data_local.enviarAlertaPoI);
            params.append('pontoDeInicioFim', this.data_local.pontoDeInicioFim);  
            params.append('statusAtivo', this.data_local.statusAtivo);  
            params.append('bloquearNoPoI', this.data_local.tempoPermanenciaMinimo);    

            if (this.data_local.horaInicialRestricao) {
                params.append('horaInicialRestricao', this.data_local.horaInicialRestricao);      
            }
            if (this.data_local.horaFinalRestricao) {
                params.append('horaFinalRestricao', this.data_local.horaFinalRestricao);      
            }

            if (this.data_local.velocidadeMaximaNoPoI) {
                params.append('velocidadeMaximaNoPoI', this.data_local.velocidadeMaximaNoPoI);      
            }
                
            if (this.data_local.tempoPermanenciaMinimo) {
                params.append('tempoPermanenciaMinimo', this.data_local.tempoPermanenciaMinimo);      
            }
                    
            axios.post(URL_SERVLET, params, {              
                    credentials: 'include', responseEncoding: 'iso88591', withCredentials: true } )
            .then((response) => {
                if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
                    this.$emit('fecharPopUpCadastroPontoInteresse'); 
                    this.$router.push({ path: '/login' });
                } else {
                    if (response.data.hasOwnProperty("error")) {
                        this.$refs.errosComponent.iniciar();
                        this.errorsValidacao = [];
                        this.errorsValidacao.push(response.data.error);
                    } else {
                        this.$emit('fecharPopUpCadastroPontoInteresse'); 
                    }
                }
            })
            .catch((error) => { 
                this.$emit('fecharPopUpCadastroPontoInteresse'); 
                /* eslint-disable no-console */  console.log("EFETUAR LOGOFF! - gravar - " + error); 
            })  
        }
         
    },
   
    formularioValido() {
        this.$refs.errosComponent.iniciar();
        this.errorsValidacao = [];

        if (!this.data_local.nome) {
            this.errorsValidacao.push(this.$t('TelaPontoInteresse_lNome') + " " + this.$t('Mensagem_Erro_Obrigatorio'));
        }

        if (!this.data_local.idGrupo) {
            this.errorsValidacao.push(this.$t('TelaPontoInteresse_lGrupo') + " " + this.$t('Mensagem_Erro_Obrigatorio'));
        }

        if (this.data_local.horaInicialRestricao && !generico.isFormatoHHMM(this.data_local.horaInicialRestricao)) {
            this.errorsValidacao.push(this.$t('TelaPontoInteresse_lHorarioInicial') + " " + this.$t('Mensagem_Erro_Invalido'));
        }

        if (this.data_local.horaFinalRestricao && !generico.isFormatoHHMM(this.data_local.horaFinalRestricao)) {
            this.errorsValidacao.push(this.$t('TelaPontoInteresse_lHorarioFinal') + " " + this.$t('Mensagem_Erro_Invalido'));
        }

        if (!this.data_local.icone) {
            this.errorsValidacao.push(this.$t('TelaPontoInteresse_lIcone') + " " + this.$t('Mensagem_Erro_Obrigatorio'));
        }

        if (this.tipoPontoInteresse === 'circulo' &&  (!this.data_local.latitude || !this.data_local.longitude)) {
            this.errorsValidacao.push(this.$t('TelaPontoInteresse_lCirculo') + " " + this.$t('Mensagem_Erro_Obrigatorio'));

            if (this.data_local.raio === 0) {
                this.errorsValidacao.push(this.$t('TelaPontoInteresse_lRaio') + " " + this.$t('Mensagem_Erro_Invalido'));
            }
        }

        if (!this.errorsValidacao.length) {
            return true;
        }   
        
      return false;
      
    },
        
  }
}
</script>